export default __webpack_public_path__ + "db1ca943d1901cda33f5df5a02cdcafb.gif";